import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { ILocationExtended } from '../../../../../type_definitions/datatypes';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { util } from '../../../../shared/util';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { TranslationService } from '../../../../shared/translation/translation.service';

@Component({
  selector: 'ag-location-detail',
  template: `
    <div class="ag-location-detail-container">
      <formly [form]="form" [fields]="fields" [model]="model"></formly>  
    </div>
  `
})
export class AgLocationDetailComponent implements ICellRendererAngularComp {
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:ILocationExtended;

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private translationService:TranslationService
  ) {
    /**/
  }

  public agInit(params:ICellRendererParams):void {
    this.model = util.copyAndExtend(params.data);
    this.fields = this.createFields();
  }

  public refresh():boolean {
    return true;
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const extraInfoTemplate:string = `
      ${this.model.companyHQ ? `<label class="col-form-label margin-right-sm"><i class="fa fa-globe"></i> ${this.translationService.instant('BPPROFILES.LOCATIONS.COMPANYHQ.LABEL')}</label>` : ''}
      ${this.model.countryHQ ? `<label class="col-form-label margin-right-sm"><i class="fa fa-flag"></i> ${this.translationService.instant('BPPROFILES.LOCATIONS.COUNTRYHQ.LABEL')}</label>` : ''}
      ${this.model.active ? `<label class="col-form-label"><i class="fa fa-check"></i> ${this.translationService.instant('BPPROFILES.LOCATIONS.ACTIVE.LABEL')}</label>` : ''}
    `;

    return [
      this.formlyService.aValue('name')
        .withoutInfo()
        .build(),
      this.formlyService.aValue('address')
        .withFormat(() => this.formattingService.formatLocationHtml(this.model))
        .build(),
      this.formlyService.aGroup('homePage')
        .withFields([
          this.formlyService.aLink(this.model.homePage)
            .withoutWrapper()
            .withWrapperClass('col-sm-12')
            .withExtraOptions({
              templateOptions: {
                target: '_blank'
              }
            })
            .build()
        ])
        .build(),
      this.formlyService.aGroup('phoneGroup')
        .withoutWrapper()
        .withFields([
          this.formlyService.aValue('telephoneNumber')
            .withWrapperClass('col-sm-6')
            .build(),
          this.formlyService.aValue('faxNumber')
            .withWrapperClass('col-sm-6')
            .build()
        ])
        .build(),
      this.formlyService.aValue('companyRegisteredName')
        .withoutInfo()
        .build(),
      this.formlyService.aValue('vatNumber')
        .withoutInfo()
        .build(),
      this.formlyService.aTemplate(extraInfoTemplate)
        .build()
    ];
  }
}